import { displayDigits } from '../../utils/displayDigits';
import React from 'react';
import { useAnnualPlanTranslation } from '../../hooks/useAnnualPlanTranslation';
import { NmCard } from '../../components/NmCard';

interface WeeklyLoadSliderCardProps {
  tssLoadPercent: number;
  avgTSS: number;
  onChange: (percent: number) => void;
  style?: React.CSSProperties;
}

/** 75–125% weekly load multiplier — shared on CTL + TSS review wizard steps. */
export function WeeklyLoadSliderCard({
  tssLoadPercent,
  avgTSS,
  onChange,
  style,
}: WeeklyLoadSliderCardProps) {
  const { t } = useAnnualPlanTranslation();

  return (
    <NmCard style={{ marginTop: 12, ...style }}>
      <div
        style={{
          fontSize: 10,
          fontWeight: 700,
          color: 'var(--fg-3)',
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          marginBottom: 10,
        }}
      >
        {t('annualPlan.weeklyLoad.adjustmentTitle')}
      </div>
      <p style={{ margin: '0 0 12px', color: 'var(--fg-3)', fontSize: 12, lineHeight: 1.8 }}>{t('annualPlan.weeklyLoad.adjustmentHint')}</p>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
        <span style={{ fontSize: 11, color: 'var(--fg-4)', width: 36 }}>{displayDigits('75%')}</span>
        <input
          type="range"
          min={75}
          max={125}
          step={1}
          value={tssLoadPercent}
          onChange={e => onChange(parseInt(e.target.value, 10))}
          style={{ flex: 1, accentColor: 'var(--color-accent)' }}
        />
        <span style={{ fontSize: 11, color: 'var(--fg-4)', width: 40, textAlign: 'right' }}>{displayDigits('125%')}</span>
      </div>
      <div style={{ fontSize: 11, color: 'var(--fg-3)', textAlign: 'center' }}>
        {t('annualPlan.weeklyLoad.summary', { percent: tssLoadPercent, avg: avgTSS })}
      </div>
    </NmCard>
  );
}
